// components/GastosDatos/TotalExpensesBox.jsx
import { Typography, Paper } from "@mui/material";

export default function TotalProfitBox({ total }) {
  return (
    <Paper
      elevation={3}
      sx={{
        p: 1,
        borderRadius: 2,
        backgroundColor: "#2d8bba",
        textAlign: "center",
        boxShadow: "5px 5px 15px rgba(0,0,0,0.2)",
        width: "16%",
        ml: 2.5 
      }}
    >
      <Typography variant="body2" color="white">
        Ganancia Total
      </Typography>
      <Typography variant="h5" color="white" sx={{ mt: 1 }}>
        ${total !== null ? total : "Cargando..."}
      </Typography>
    </Paper>
  );
}
